import React from "react";

import { iCommunityProfile, generalInfo, meetingsSchema, profileImagesSchema } from "ps-shared";
import { FormikWizard } from "src/components/Forms/FormikWizard";
import ProfileImages from "src/components/My/Profiles/Forms/ProfileImages";
import Meetings from "src/components/My/Profiles/Forms/Community/Meetings";
import { GeneralInfo } from "src/components/My/Profiles/Forms/Community/GeneralInfo";
import { toast } from "react-toastify";
import { navigate } from "gatsby";
import { ProfileManageMode } from "src/models/ProfileManageMode";
import { ProfileWizardCbData, ProfileWizardCbResult } from "src/components/My/Profiles/ProfileWizard";

interface CommunityProfileWizardProps {
  profile: iCommunityProfile;
  mode: ProfileManageMode;
  submitCb: (data: ProfileWizardCbData) => Promise<ProfileWizardCbResult>;
  nextCb: (data: ProfileWizardCbData) => Promise<ProfileWizardCbResult>;
}
interface CommunityProfileWizardState {
  formInit: any;
}

export default class CommunityProfileWizard extends React.Component<
  CommunityProfileWizardProps,
  CommunityProfileWizardState
> {
  private wizRef = React.createRef<FormikWizard>();

  constructor(props: CommunityProfileWizardProps) {
    super(props);
    const communityForm = generalInfo.concat(meetingsSchema).concat(profileImagesSchema).cast();
    if (this.props.mode === ProfileManageMode.edit) {
      // convert the server record to community profile profile
      Object.keys(this.props.profile).forEach((prop: string) => {
        // eslint-disable-next-line no-prototype-builtins
        if (this.props.profile[prop] !== undefined && communityForm.hasOwnProperty(prop)) {
          (communityForm as any)[prop] = this.props.profile[prop];
        }
      });
    }
    this.state = {
      formInit: communityForm,
    };
  }

  public cancel() {
    navigate("/my/profiles/");
  }

  // tslint:disable:max-line-length
  public render() {
    return (
      <>
        <FormikWizard
          ref={this.wizRef}
          initialValues={this.state.formInit}
          validationSchemas={[generalInfo, profileImagesSchema, meetingsSchema]}
          mode={this.props.mode}
          onCancel={() => {
            this.cancel();
          }}
          onSubmit={(values: any) => {
            return new Promise<void>((resolve, reject) => {
              this.props
                .submitCb({ values, page: undefined })
                .then(() => {
                  resolve();
                })
                .catch((error: ProfileWizardCbResult) => {
                  if (error.errs) {
                    error.errs.forEach((e: string) => {
                      toast.error(e);
                    });
                  } else {
                    toast.error("Oops! Something bad happened, pls try again");
                  }
                  reject();
                });
            });
          }}
          onNext={(values: any, page: number): Promise<ProfileWizardCbResult> => {
            return new Promise((resolve, reject) => {
              this.props
                .nextCb({ values, page })
                .then((result) => {
                  return resolve(result);
                })
                .catch((error: ProfileWizardCbResult) => {
                  if (error.errs) {
                    error.errs.forEach((e: string) => {
                      toast.error(e);
                    });
                  } else {
                    toast.error("Oops! Something bad happened, pls try again");
                  }
                  reject();
                });
            });
          }}
        >
          <FormikWizard.Page name="About your Community Group">
            {(values: any) => (
              <div>
                <GeneralInfo values={values} profile={this.props.profile} />
              </div>
            )}
          </FormikWizard.Page>
          <FormikWizard.Page name="Images">
            {(values: any) => (
              <div>
                <ProfileImages values={values} slug={values.slug} />
              </div>
            )}
          </FormikWizard.Page>
          <FormikWizard.Page name="Meetings">
            {(values: any) => (
              <div>
                <Meetings values={values} profile={this.props.profile} />
              </div>
            )}
          </FormikWizard.Page>
        </FormikWizard>
      </>
    );
  }
}
